import {
    DealerRecallDTO,
    DealerRecallClient_V1,
    AXDocumentDTO,
    DealerRecallSearchDTO,
    DealerRecallVinDTO,
    ExportDTO,
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';

export default class RecallService {
    private readonly _dealerRecallClient: DealerRecallClient_V1;

    constructor() {
        this._dealerRecallClient = new DealerRecallClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    public DealerRecalls(dealerAccountUid: string, dto: DealerRecallSearchDTO): Promise<Array<DealerRecallDTO>> {
        return this._dealerRecallClient.warrantyRecalls(dto, dealerAccountUid);
    }

    public DealerRecallVins(dealerAccountUid: string, dto: DealerRecallSearchDTO): Promise<Array<DealerRecallVinDTO>> {
        return this._dealerRecallClient.warrantyRecallVins(dto, dealerAccountUid);
    }

    public RecallAttachment(dealerAccountUid: string, attachmentRecId: number): Promise<AXDocumentDTO> {
        return this._dealerRecallClient.recallAttachment(dealerAccountUid, attachmentRecId);
    }
    
    public ExportRecallVins(dealerAccountUid: string, dto: DealerRecallSearchDTO): Promise<ExportDTO> {
        return this._dealerRecallClient.exportRecallVins(dto, dealerAccountUid);
    }
}